module.exports = __webpack_public_path__ + "static/media/BM_ORU_110.3b2f4e18.png";